import { ArrowUpRightIcon, ArrowRightIcon } from '@heroicons/react/24/outline';
import posts from '../data/blog-posts.json';

export default function LatestPosts() {
  return (
    <section className="home-section home-latest">
      <div className="home-shell">
        <div className="home-section-heading">
          <div><p className="home-eyebrow">04 / From the notebook</p><h2 className="home-section-title">Latest posts</h2></div>
          <a href="https://blog.angeloruiz.com" className="home-text-link">Visit the WordPress blog <ArrowUpRightIcon aria-hidden="true" /></a>
        </div>
        <p className="home-section-intro">Notes on IT operations, automation and building useful software. Read the full articles on my WordPress blog, where I share technical approaches and lessons from working across infrastructure and business systems.</p>
        <div className="home-post-grid">
          {posts.slice(0, 6).map((post) => (
            <article key={post.id} className="home-post-card">
              {post.coverImage?.url && <div className="home-post-image"><img src={post.coverImage.url} alt={post.coverImage.alt || `Illustration for ${post.title}`} width="400" height="225" loading="lazy" decoding="async" /></div>}
              <div className="home-post-content">
                <time dateTime={post.date}>{post.date.slice(0, 10)}</time>
                <h3><a href={post.link}>{post.title}</a></h3>
                <p>{post.excerptText}</p>
                <a href={post.link} className="home-text-link">Read on the blog <ArrowRightIcon aria-hidden="true" /></a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
